import {SOPutSimpleAttributePermission} from '../../core/simple-attribute-permission/so-put-simple-attribute-permission';
import {SimpleAttributePermissionCore} from './simple-attribute-permission.core';
import {SOGetSimpleAttributePermission} from '../../core/simple-attribute-permission/so-get-simple-attribute-permission';
import {FormField, SelectionOption} from 'lionheartland';
import {putSimpleAttributePermissionFormFieldOptions} from './put-simple-attribute-permission-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {SimpleAttributeCore} from '../simple-attribute/simple-attribute.core';
import {SOGetSimpleAttribute} from '../../core/simple-attribute/so-get-simple-attribute';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutSimpleAttributePermission extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putSimpleAttributePermissionFormFieldOptions);

  RequestClass = SOPutSimpleAttributePermission

  constructor(
    public entityCore: SimpleAttributePermissionCore
  ) {
    super();
    if (putSimpleAttributePermissionFormFieldOptions.simpleAttribute) {
      putSimpleAttributePermissionFormFieldOptions.simpleAttribute.makeCore = true;
    }
    if (putSimpleAttributePermissionFormFieldOptions.project) {
      putSimpleAttributePermissionFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier('whiteList'),
      this.getFormValueFromIdentifier('permissionType'),
      this.getFormValueFromIdentifier(
        'simpleAttribute',
        SOGetSimpleAttribute,
      ),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}